<template>
<div class="page">
<v-container fluid>

  <v-card outlined elevation="3" rounded="lg" class="mx-auto mt-3" max-width="1000">
    <v-form ref="form" @submit.prevent="atualizarDadosDoProfissional">

    <v-card-title class="d-flex justify-center">
      <v-icon class="p-2">mdi-account</v-icon>
      Atualização Cadastral
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-text-field
            label="Nome*"
            v-model="dados.nome"
            outlined
            readonly
            hide-details="auto"
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            label="Nome Social"
            v-model="dados.nomeSocial"
            outlined
            dense
            hide-details="auto"
          >
            <template v-slot:append-outer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                Nome social é a designação pela qual a pessoa travesti ou transexual se identifica e é socialmente reconhecida. <br />
                DEVERÁ SER COMPOSTO POR PRENOME, ACRESCIDO DO(S) SOBRENOME(S) FAMILIAR(ES) CONSTANTE(S) DO NOME CIVIL,<br />
                não podendo ser irreverente ou atentar contra o pudor.
              </v-tooltip>
            </template>

          </v-text-field>
        </v-col>

        <v-col cols="6">
          <v-text-field
            label="E-mail*"
            v-model="dados.email"
            dense
            outlined
            readonly
            hide-details="auto"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            label="E-mail Secundário"
            v-model="dados.emailSecundario"
            dense
            outlined
            hide-details="auto"
            maxlength="252"
            :rules="[
              (v) => !v || $email(v),
            ]"
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-text-field
            label="Telefone*"
            v-model="dados.telefone"
            v-mask="'(##) #####-####'"
            dense
            outlined
            hide-details="auto"
            hint="Número que seja de prefrência WhatsApp"
            :rules="[(v) => $required(v), (v) => $length(v, 15)]"
          >
            <template v-slot:append>
                <scae-autofill-tooltip message="Preencha apenas com números. O sistema aplicará automaticamente a máscara no formato (xx) xxxxx-xxxx." />
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            label="Origem*"
            v-model="dados.origem"
            dense
            outlined
            readonly
            hide-details="auto"
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-text-field
            :label="labelVwEo"
            v-model="dados.vwEoNome"
            dense
            outlined
            hide-details="auto"
            readonly
            :rules="[(v) => $required(v)]"
          ></v-text-field>
        </v-col>

        <v-col cols="6" v-if="origemEscola || origemEscolaCargo">
          <v-text-field
            label="Escola*"
            v-model="dados.escola"
            dense
            outlined
            hide-details="auto"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="6" v-if="!origemEscola">
          <v-select
            v-model="dados.setor"
            :items="lista.setores"
            item-value="id"
            item-text="nome"
            label="Setor*"
            dense
            outlined
            hide-details="auto"
            :rules="[(v) => $requiredIfTrue(v, !origemEscola)]"
          ></v-select>
        </v-col>

        <v-col cols="6" v-if="!origemEscola">
          <v-select
            v-model="dados.funcao"
            :items="lista.funcoes"
            item-value="id"
            item-text="nome"
            label="Função*"
            dense
            outlined
            hide-details="auto"
            :rules="[(v) => $requiredIfTrue(v, !origemEscola)]"
          ></v-select>
        </v-col>
        <v-col cols="6" v-if="origemEscola">
          <v-text-field
            v-model="dados.funcaoDescricao"
            label="Função*"
            dense
            outlined
            hide-details="auto"
            readonly
          ></v-text-field>
        </v-col>
        
        <v-col cols="6" v-if="origemEscola">
          <v-select
            v-model="dados.disciplina"
            :items="lista.disciplinas"
            item-value="id"
            item-text="nome"
            label="Disciplina*"
            dense
            outlined
            hide-details="auto"
            :rules="[(v) => $requiredIfTrue(v, origemEscola)]"
          ></v-select>
        </v-col>
      </v-row>

    </v-card-text>

    <v-card-actions class="d-flex justify-center">
      <v-btn
        color="primary"
        type="submit"
      >Salvar</v-btn>
    </v-card-actions>
  </v-form>

  </v-card>
</v-container>
</div>
</template>
  
  <script>
  import ManterFuncaoService from "~/services/manter-funcao.service"
  import ManterSetorService from "~/services/manter-setor.service"
  import { LOGIN } from 'store/modules/auth';
  export default {
    name: "AtualizacaoCadastralPrimeiroAcesso",
    mixins: [ManterFuncaoService, ManterSetorService],
    data: () => ({
      dados: {
        nome: null,
        nomeSocial: null,
        email: null,
        emailSecundario: null,
        telefone: null,
        origem: null,
        vwEoNome: null,
        vwEoCodigo: null,
        escola: null,
        nomeGre: null,
        funcao: null,
        setor: null,
        tipoLotacao: null,
      },
      lista: {
        setores: [],
        funcoes: [],
        disciplinas: [],
        escolas:  [],
      },
      origens: [],
      listaGerenciasRegionais: [],
      listaSecretarias: [],
    }),
    methods: {
      montarDadosUsuario(usuario) {
        this.dados = {
          ...usuario,
          telefone: this.$formatarTelefone(usuario?.telefone),
        };
        if (this.origemEscola) {
          this.lista.disciplinas = this.dados.disciplinas;
          if (this.lista.disciplinas.length === 1) {
            this.dados.disciplina = this.lista.disciplinas[0].id;
          }
          this.dados.funcaoDescricao = "Professor";
        } else {
          this.listarSetores();
        }
      },
      listarSetores() {
        const params = {
          ativo: true,
        };
        params.origem = this.origemSee ? 2 : 1;

        this.$buscarSetores({params}).then(({ data }) => {
          this.lista.setores = data.itens;
        });
      },
      atualizarDadosDoProfissional() {
        if(this.$validarFormulario()) {
          const payload = {
            ...this.dados,
            telefone: this.$unMask(this.dados.telefone),
          };
          
          this.$atualizarDadosCadastrais(this.$user.username, payload).then(() => {
            this.$renovarToken().then(({ data }) => {
              if (data.sucesso) {
                this[LOGIN](data);
                this.$atualizarCacheMenu().then(() => {
                  this.$notifySuccess("Dados cadastrais atualizados com sucesso.");
                  this.$toHome();
                });
              }
            });
          });
        }
      },
    },
    computed: {
      origemEscola() {
        return this.dados.tipoLotacao == 1;
      },
      origemEscolaCargo() {
        return this.dados.tipoLotacao == 2;
      },
      origemGre() {
        return this.dados.tipoLotacao == 3;
      },
      origemSee() {
        return this.dados.tipoLotacao == 4;
      },
      labelVwEo() {
        return this.origemSee ? "Secretaria Executiva*" : "Nome da GRE*";
      },
    },
    watch: {
      'dados.setor': function (val) {
        if (this.origemEscola) return;
        this.dados.funcao = null;
        this.lista.funcoes = this.lista.setores.find(setor => setor.id === val)?.funcoes || [];
      }
    },
    mounted() {
        this.$obterDadosAtualizacaoCadastral(this.$user.username).then(({ data }) => {
           this.montarDadosUsuario(data.resposta);
        });
    },
  };
  </script>